import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

import type { IWbuButtonProps } from '../WbuButton.props';

export const props = withCompInfo<IWbuButtonProps, any>()(
  ['compData', 'experiments'],
  ({ compData, experiments }) => {
    const shouldResolveLinksInPlace = Boolean(
      experiments['specs.thunderbolt.resolveLinksInPlace'],
    );
    return {
      ...compData,
      link: shouldResolveLinksInPlace
        ? compData.link
        : compData.link?.resolvedLink,
    };
  },
);

export default createComponentMapperModel({
  props,
});
